import React from 'react';
import '../../../styles/pages/crm.scss';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import PersonDetailsDropdownModal from '../../crm/PersonDetailsDropdownModal';
import DealDetailsDropdownModal from '../../crm/DealDetailsDropdownModal';
import OrganizationsDetailsDropdownModal from '../../crm/OrganizationDetailsDropdownModal';

const DetailsDropdown = ({ itemType }) => {
    let deleteModal;
    let dropdownHeight;
    let dropdownSize;

    switch (itemType) {
        case 'organization':
            deleteModal = <OrganizationsDetailsDropdownModal />;
            dropdownSize = 'md';
            dropdownHeight = 35;
            break;
        case 'person':
            deleteModal = <PersonDetailsDropdownModal />;
            dropdownSize = 'md';
            dropdownHeight = 35;
            break;
        case 'deal':
            deleteModal = <DealDetailsDropdownModal />;
            dropdownSize = 'lg';
            dropdownHeight = 45;
            break;
        default:
            break;
    }
    return (
        <div className='deleteDetailButton' style={{ height: dropdownHeight }}>
            <DropdownButton title='•••' id='dropdown-menu-align-right' size={dropdownSize} variant='light'>
                <Dropdown.Item eventKey='1'>{deleteModal}</Dropdown.Item>
            </DropdownButton>
        </div>
    );
};

export default DetailsDropdown;
